import { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { TooltipProvider } from "components/ui/tooltip";
import "./Layout.scss";

const Layout = ({ children }: { children?: React.ReactNode }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <TooltipProvider delayDuration={200}>
      <div className="relative flex min-h-screen flex-col bg-background text-foreground">
        {/* Ambient gradient decorations */}
        <div
          aria-hidden
          className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
        >
          <div className="absolute -top-32 left-1/4 h-80 w-80 rounded-full bg-primary/10 blur-3xl" />
          <div className="absolute bottom-0 right-0 h-96 w-96 rounded-full bg-accent/10 blur-3xl" />
        </div>

        <Header onMobileMenuToggle={() => setMobileOpen(true)} />

        <div className="flex flex-1 overflow-hidden">
          <Sidebar
            mobileOpen={mobileOpen}
            onMobileOpenChange={setMobileOpen}
          />

          <main className="flex-1 overflow-auto p-4 sm:p-6 lg:p-8">
            {children}
          </main>
        </div>
      </div>
    </TooltipProvider>
  );
};

export default Layout;
